import { render } from "./BadgeInfo.vue?vue&type=template&id=27cf56d4"
import script from "./BadgeInfo.vue?vue&type=script&lang=js"
export * from "./BadgeInfo.vue?vue&type=script&lang=js"

import "./BadgeInfo.vue?vue&type=style&index=0&id=27cf56d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__